import webIcon from '../../Assets/images/icons/web.png';
import frontIcon from '../../Assets/images/icons/front-end.png';
import serviceIcon from '../../Assets/images/icons/web-service.png';
import gameIcon from '../../Assets/images/icons/gamedev.png';
import designIcon from '../../Assets/images/icons/design.png';


export const SKILLS = [
	{ name: 'Frontend Dev', icon: frontIcon },
	{ name: 'Backend Dev', icon: webIcon },
	{ name: 'Web Service', icon: serviceIcon },
	{ name: 'UI Design', icon: designIcon },
	{ name: 'Game Dev', icon: gameIcon },
];
